import { hbs } from 'ember-cli-htmlbars';
export default hbs("<@wrapperItem>\n  <Ui::Tag @color={{@color}} data-test-tag-list-item=\'{{@index}}\' ...attributes>\n    {{yield}}\n  </Ui::Tag>\n</@wrapperItem>")